import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useSystem from '@hooks/useSystem'

import type { TemplateQualityControlCategoryModel } from '@models/types'

const confirmDelete = (deleteCategory: Function) => {
  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Remove QC Category?',
    })
    .then(({ value }) => {
      if (value){
        deleteCategory()
      }
    })
}

type UseSystemPayload = ReturnType<typeof useSystem>

interface CategoryListItemProps {
  callbacks: {
    createOrEditQualityControlCategory: UseSystemPayload['callbacks']['createOrEditQualityControlCategory'],
    deleteCategory: () => void,
  },
  qualityControlCategory: TemplateQualityControlCategoryModel,
}

const CategoryListItem = (props: CategoryListItemProps) => {
  const {
    callbacks: {
      createOrEditQualityControlCategory,
      deleteCategory,
    },
    qualityControlCategory,
  } = props

  return (
    <DashboardModuleListItem
      title={qualityControlCategory.title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {qualityControlCategory.key}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => createOrEditQualityControlCategory(qualityControlCategory)}
          type="edit"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(deleteCategory)}
          type="delete"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default CategoryListItem
